import { mapGranularityKeyToLocalePrefix } from '../../utility/filters-helpers';

/**
 *
 * @example
 * ```
 * const options = Dropdown2
 *   .createOptionsFromGranularity(_)('age_groun_id', [1,2,3]);
 * ```
 */
export const createOptionsFromGranularity =
    (_: (key: string) => string) => (key: string, values?: (string | number)[]) => {
        return values == null
            ? values
            : values.map((i) => ({ value: i, label: _(mapGranularityKeyToLocalePrefix(key) + i) }));
    };

function getScrollableParent(element) {
    while (element && element !== document.body) {
        const style = window.getComputedStyle(element);
        if (/(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX)) {
            return element;
        }
        element = element.parentElement;
    }
    return document.documentElement;
}

export const checkIsEnoughSpaceAboveForMenu = ({
    triggerRect,
    triggerNode,
    menuNode,
}: {
    triggerRect: ClientRect;
    triggerNode: HTMLElement;
    menuNode: HTMLElement;
}) => {
    const scrollParentRect = getScrollableParent(triggerNode)?.getBoundingClientRect();

    const spaceAbove = triggerRect.top - (scrollParentRect?.top || 0);
    const menuHeight = menuNode?.clientHeight || 0;

    return spaceAbove > menuHeight;
};
